import {
  actionCardChipTitle,
  actionCardMention,
} from '@littlebird/action-cards';
import { getSDK } from '@littlebird/sdk';
import { observer } from 'mobx-react-lite';
import { type ReactNode } from 'react';

import {
  MentionChipContent,
  mentionChipClassName,
  mentionChipTitle,
} from '@/features/mention';
import { cn } from '@/lib/utils';

import { ActionCardMentionIcon } from './ActionCardMentionIcon';

/** A card linked in the user's own message, drawn as the chip it has in the composer. The link's text stands in
 * until the card loads */
export const ActionCardMentionChip = observer(
  ({ localId, children }: { localId: number; children: ReactNode }) => {
    const card = getSDK().stores.actionCards.getByLocalId(localId);
    const title = card ? actionCardChipTitle(card) : null;
    if (!card || !title) return <span>{children}</span>;

    const mention = actionCardMention(card, title);
    return (
      <span
        // Never wider than the message, so a long title truncates in a narrow chat
        className={cn(
          mentionChipClassName(),
          'not-prose select-text max-w-full'
        )}
        title={mentionChipTitle(mention)}
      >
        <MentionChipContent
          mention={mention}
          icon={<ActionCardMentionIcon cardId={card.id} />}
        />
      </span>
    );
  }
);
